<template>
  <div
    v-editable="blok"
    class="VideoPlayer"
    :class="desktopWidth('md')"
  >
    <div v-if="isYoutube" class="w-full aspect-wide">
      <iframe
        :src="`https://www.youtube.com/embed/${blok.youtubeId}`"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
        class="w-full h-full"
      />
    </div>

    <video
      v-else-if="checkIfVideoFile(blok.videoUrl)"
      playsinline
      :autoplay="blok.autoplay"
      :muted="blok.autoplay"
      :loop="blok.autoplay"
      :controls="blok.controls"
      class="w-full"
    >
      <source :src="blok.videoUrl" type="video/mp4">
    </video>
  </div>
</template>

<script setup lang="ts">
import { StoryBlokPropBase } from '~/constants/types/storyblok';
import useDesktopWidth from '~/composeables/useDesktopWidth';
import { checkIfVideoFile } from '~/util/imageUtil';

type Props = StoryBlokPropBase & {
  videoUrl: string,
  autoplay: boolean,
  controls: boolean,
  youtubeId?: string
}

const props = defineProps<{
  blok: Props,
}>();

const { desktopWidth } = useDesktopWidth(props);

const isYoutube = computed(()=> {
  return props.blok.youtubeId && props.blok.youtubeId.trim() !== '';
});

</script>

<style scoped lang="postcss">
</style>
